/* tslint:disable */
/* eslint-disable */
/**
 * Viterbit API
 * This is the documentation for viterbit\'s apps
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RespondPendingFileCommand
 */
export interface RespondPendingFileCommand {
    /**
     * 
     * @type {boolean}
     * @memberof RespondPendingFileCommand
     */
    accept: boolean;
    /**
     * 
     * @type {string}
     * @memberof RespondPendingFileCommand
     */
    employeeId?: string | null;
}

/**
 * Check if a given object implements the RespondPendingFileCommand interface.
 */
export function instanceOfRespondPendingFileCommand(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "accept" in value;

    return isInstance;
}

export function RespondPendingFileCommandFromJSON(json: any): RespondPendingFileCommand {
    return RespondPendingFileCommandFromJSONTyped(json, false);
}

export function RespondPendingFileCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): RespondPendingFileCommand {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'accept': json['accept'],
        'employeeId': !exists(json, 'employeeId') ? undefined : json['employeeId'],
    };
}

export function RespondPendingFileCommandToJSON(value?: RespondPendingFileCommand | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'accept': value.accept,
        'employeeId': value.employeeId,
    };
}

